import { connect } from 'react-redux';
import {
  selectInteractionManagementActiveColumns,
  areAllColNotActive,
  selectTimeFormat,
  totalRatio,
  activeMenuItems,
  areAllActive,
} from '../../redux/modules/columnFilterMenus/selectors';
import { setCurrentEntity, fetchData } from '../../redux/modules/entities';
import {
  setExpanded,
  setSorted,
  setSelected,
  removeSelected,
  startInteractionManagement,
  toggleBulkInteractionChange,
  endInteractions,
} from '../../redux/modules/reporting/interactionManagement';
import { updateQueuesColumnFilter, toggleTimeFormat } from '../../redux/modules/columnFilterMenus';
import {
  selectInteractionManagementTableData,
  selectInteractionManagementSorted,
  selectInteractionManagementExpanded,
  selectInteractionManagementSelected,
  getBulkSelected,
} from '../../redux/modules/reporting/interactionManagement/selectors';
import {
  selectSupervisorToolbarSilentMonitoringInteractionId,
  selectSupervisorToolbarSilentMonitoringStatus,
  selectLoadingUserStatus,
} from '../../redux/modules/supervisorToolbar/selectors';
import { getCurrentAgentId } from '../../redux/modules/userData/selectors';
import { getHelpLink } from '../EntityTable/selectors';
import { entitiesMetaData } from '../../redux/modules/entities/metaData';

import Layout from './layout';
import { isInIframe } from 'serenova-js-utils/browser';

const TABLE_TYPE = 'interactionManagement';

export const mapStateToProps = (state, props) => ({
  pageTitle: entitiesMetaData[TABLE_TYPE] ? entitiesMetaData[TABLE_TYPE].pageTitle : '',
  pageHelpLink: getHelpLink(state),
  getCurrentAgentId: getCurrentAgentId(state),
  areAllColNotActive: areAllColNotActive(state, {
    menuType: 'Columns',
    tableType: TABLE_TYPE,
  }),
  activeQueueFilters: activeMenuItems(state, { tableType: TABLE_TYPE, menuType: 'Queues' }).toJS(),
  queuesAreAllActive: areAllActive(state, { tableType: TABLE_TYPE, menuType: 'Queues' }),
  activeColumns: selectInteractionManagementActiveColumns(state, props),
  totalRatio: totalRatio(state, props),
  twelveHourFormat: selectTimeFormat(state, props),
  tableData: selectInteractionManagementTableData(state, props),
  expanded: selectInteractionManagementExpanded(state, props),
  selected: selectInteractionManagementSelected(state, props),
  sorted: selectInteractionManagementSorted(state, props),
  monitoredId: selectSupervisorToolbarSilentMonitoringInteractionId(state, props),
  monitoringStatus: selectSupervisorToolbarSilentMonitoringStatus(state, props),
  insideIframe: !isInIframe(),
  loadingUserStatus: selectLoadingUserStatus(state),
  getBulkSelected: getBulkSelected(state, props),
});

export const actions = {
  toggleTimeFormat,
  updateQueuesColumnFilter,
  setExpanded,
  setSelected,
  setSorted,
  removeSelected,
  fetchData,
  startInteractionManagement,
  setCurrentEntity,
  onBulkClick: toggleBulkInteractionChange,
  endInteractions: endInteractions,
};

export default connect(mapStateToProps, actions)(Layout);
